import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    MenuItem,
  CircularProgress,
  TextField,
  Stack,
  Tooltip,
  Typography,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  FormLabel,
  Radio,
  FormControl,
} from "@mui/material";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useEffect, useState } from 'react';
import { getUomData, getSourceCategoryDropdown, getManufacturerCategoryDetails, lotDispatch } from "../../services/FortificationService";
import Autocomplete from "@mui/material/Autocomplete";
import { ListboxComponent } from "../InfiniteScroll/ListboxComponent";
import { useAppDispatch } from "../../services/StoreHooks";
import Paper from "@mui/material/Paper";
import { getAllInventoryLots } from "../../services/InventoryService";
import { MobileDatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import ClearIcon from "@mui/icons-material/Clear";
import { useSelector } from "react-redux";
import { getTargetManufacturerFromLicense } from "../../services/FortificationService";
import { useLocation } from "react-router";
import useTranslatewrapper from "../useTranslateWrapper";
import { useParams } from "react-router-dom";
import { lengthAndValidCharactersInStringCheck, translateDateSelectActionButtons } from "../../commonFunctions";

function DispatchLotComponent({handleCloseDispatch, categoryId}) {
  const {translate} = useTranslatewrapper()
  const currentLocation = useLocation();
  const categoriesRedux = useSelector((state) => state.categoriesData);
  const [searchString, setSearchString] = useState("");
  const [uomData, setUomData] = useState([{name: 'KG'}]);
  const [open1, setOpen1] = React.useState(false);
  const [confirmDialog, setConfirmDialog] = React.useState(false);
  const [categoryDropdownData, setCategoryDropdownData] = useState({});
  const [sizeLoading, setSizeLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [manufacturersPageNumber, setmanufacturersPageNumber] = useState(1);
  const pageSize = 10;
  const [activeRow, setActiveRow] = useState(null);
  const [chipData, setChipData] = useState([]);
  const [id, setId] = useState();
  const [dropDown, setDropDown] = useState([]);
  const [deletedId, setDeleteId] = useState();
  const [open, setOpen] = React.useState(false);
  const [hideSaveButton, setHideSaveButton] = React.useState(true);
  const [instructions, setInstructions] = useState("")
  const [value, setValue] = useState(moment().local().format("yyyy-MM-DD"));
  const [manufacturerType, setManufacturerType] = useState('PUBLIC');
  const [manufacturerId, setManufacturerId] = useState("");
  const [manufacturerCount , setManufacturerCount] = useState(0);
  const [frkManufacturerDetails, setFrkManufacturerDetails] = useState([]);
  const [queryparam, setQueryparam] = useState("");
  const [latestDateOfAcceptance, setLatestDateOfAcceptance] = useState("");
  const [dateError,setDateError] = useState(false);
  const [manuValue, setmanuValue] = useState("")
  const [targetManufacturerCategory, setTargetManufacturerCategory] = useState('')
  // const catMap = {
  //   2:4,
  //   4:5,
  //   5:9
  // }
  const params = useParams();
  const [outsideDispatch, setOutsideDispatch] = React.useState(false);
  const [manufSelectChoice, setManufSelectChoice] = useState('dropDown')
  const [targetManufId, setTargetManufId] = useState('')
  const [targetManufName, setTargetManufName] = useState('')
  const [targetManufLicenseNumber, setTargetManufLicenseNumber] = useState('')
  const [licenseError, setLicenseError] = useState(false)
  const [lotNo, setLotNo] = React.useState("");

  useEffect(() => {
    fetchUom();
    const catId = categoryId
    getAllInventoryLots(catId,{},pageNumber,pageSize,true).then((result) => {
      const latestDropdownData = {}
      latestDropdownData[catId] = {
        pageNumber: 1,
        pageSize: 10,
        count: result?.data?.count,
        data: [...result?.data?.data],
      };
      setCategoryDropdownData(latestDropdownData);
    })
  }, []);

  useEffect(()=>{
    const dateOfAcceptance = chipData.map(chip=> chip.dateOfAcceptance ? new Date(chip.dateOfAcceptance) : null).filter(date=> date);
    console.log(dateOfAcceptance,'maxdate')
    const date = dateOfAcceptance && dateOfAcceptance.length>0 && new Date(Math.max(...dateOfAcceptance)) || null;
    setLatestDateOfAcceptance(date);
  }, [chipData])

 

  useEffect(()=>{
    fetchFrkManufacturers(1);
  }, [manufacturerType,queryparam, targetManufacturerCategory])
  const dispatch = useAppDispatch();
  const dispatchNotification = (typ, msg) => {
    dispatch({
      type: "SHOW_NOTIFICATION",
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };
  const dispatchShowLoader = (showLoader) => {
    dispatch({
      type: "SHOW_LOADER",
      data: {
        showLoader,
      },
    });
  };
  const handleChangeFrkType = (event) => {
    setManufacturerType(event.target.value);
    setmanuValue("");
    setManufacturerId("")
    setmanufacturersPageNumber(1);
  };

  const handleChangeTargetManufacturerCategory = (event) => {
    setTargetManufacturerCategory(event.target.value);
    setmanuValue("");
    setManufacturerId("")
    setmanufacturersPageNumber(1);
  };

  const fetchFrkManufacturers = async (pageNumber1) => {
    // setSizeLoading(true);
    setmanufacturersPageNumber(pageNumber1);
    // const warehouseCat  = categoriesRedux.categories?.find(cat=> cat.name === 'School');
    const sourceCat =
      params.type === "frk-lots"
        ? categoriesRedux.categories?.find((cat) => cat.name === "NFPB")
        : params.type === "miller-lots"
        ? categoriesRedux.categories?.find((cat) => cat.name === "SCHOOL")
        : categoriesRedux.categories?.find((cat) => cat.name === "SCHOOL");
    // const prev = [...categoryDropdownData[id]?.data];
    // const manId = manufacturerId || ""
    const manufacturerCategories = await getManufacturerCategoryDetails(//add targetManufacturerCategory here
      manufacturerType,
      queryparam,
      // warehouseCat?.id,
      sourceCat?.id,
      pageNumber1,
      pageSize,
      "",
      "LOT_TO_LOT_DISPATCH"
    );

    // console.log(manufacturerCategories,"manf")/
    if (manufacturerCategories?.data) 
    {
      setManufacturerCount(manufacturerCategories?.data?.count)
      const manufacturerCategoryNames = manufacturerCategories?.data?.data?.map(
        (item) => {
          return {
            id: item.id,
            name: item.name,
          };
        }
      );

      setFrkManufacturerDetails((d)=> pageNumber1!==1  ? [...d, ...manufacturerCategoryNames] : manufacturerCategoryNames);
    }
  };

  const checkIfDisabled = ()=> {
    let isDisabled = false;
    if(chipData && chipData.length > 0){
      isDisabled = !value || (!outsideDispatch && !manufacturerId && !targetManufId)
      chipData.forEach(eData=> {
        isDisabled = isDisabled || !eData.size || !eData.quantity || eData.quantity == 0 || !eData.unit;
      })
    }else{
      isDisabled = true;
    }
    return isDisabled || dateError
  }

  const fetchData = async (id, pageNumber1) => {
    setSizeLoading(true);
    setPageNumber(pageNumber1);
    const prev = [...categoryDropdownData[id]?.data];
    const dropdownData = await getAllInventoryLots(id,{
      searchCriteriaList :[
        {
          "key": "batchNo",
          value: searchString || ""
        },
        
      ]
    },pageNumber1,
      pageSize, true)
    const latestDropdownData = { ...categoryDropdownData };
    const currentUsed = prev?.filter(
      (d) =>
        !dropdownData?.data?.data?.some((dd) => dd.id === d.id)
    );

    latestDropdownData[id] = {
      pageNumber: pageNumber1,
      pageSize,
      count: dropdownData?.data?.count,
      data: [
        ...(pageNumber1 !== 1 ? prev : [...currentUsed]),
        ...dropdownData?.data?.data,
      ],
    };
    setCategoryDropdownData(latestDropdownData);
    setSizeLoading(false);
    return latestDropdownData;
  };

  const handleChangeDate = (e) => {
    setValue(e);
  };
  const checkValidated = (idx) => {
    let validated = [];

    let dataNew = [...chipData];
    if (dataNew[idx]?.id === "") return validated;
    dataNew = dataNew.filter(
      (ele) =>
        ele.id != "" &&
        ele.size !== "" &&
        ele.quantity !== "" &&
        ele.uomId !== "" &&
        ele.unit !== ""
    );
    dataNew.splice(idx, 1);

  
    return [];
  };

  const handleAddItem = async (id) => {
    // setHideSaveButton(false);
    // setHideSaveButton(false);

    setSearchString("");
    setId(id);
    setChipData([
      ...chipData,
      {
        id: "",
        size: "",
        unit: "",
        quantity: "",
        uomId: "",
        remaining: "",
        chipId: id,
        categoryId: id,
        readOnly: false,
      },
    ]);
    setDropDown([]);
  };

  const handleDeleteRow = (idx) => {
    // if (
    //   (!hideSaveButton ||
    //     chipData?.filter((data) => data.id == "")?.length > 0) &&
    //   chipData[idx].id
    // ) {
    //   dispatchNotification("error", [
    //     "Please save the unsaved material detail changes to proceed",
    //   ]);
    // } else {
    //   setDeleteId(idx);
    //   let errMessage = checkValidated(idx);

    //   errMessage.length > 0
    //     ? dispatchNotification("error", errMessage)
    //     : setOpen(true);
    // }

    setChipData(d=> {
      d.splice(idx,1)
      return [...d]})
  };

  const searchResults = (e, data) => {
    setSearchString(e?.target?.value || "");
  };

  const fetchUom = async (id) => {
    const uomData = await getUomData();
    uomData && setUomData(uomData.data.data);
  };
  const handleClickCloseDialog = () => {
    setOpen1(false);
  };

  const handleClosConfirmation = () => {
    setConfirmDialog(false);
  };
  const handleClickSaveCloseDialog = () => {
    setOpen1(false);
  };
  const handleSave = async ()=> {
    dispatchShowLoader(true);
    const body = {
      lotProperties: [
        {
          name: 'manufacture_lotNumber',
          value: lotNo
        }
      ],
    };
    body.mixes = chipData.map(d => {return {"sourceLotId": d.size,
    "quantityUsed": d.quantity,
    "uomId": d.uomId}})
    body.dateOfDispatch = moment(value.$d?.toDateString()).format('yyyy-MM-DD');
    body.comments = instructions;
    body.targetManufacturerId = manufacturerId || targetManufId;
    body.externalDispatch = outsideDispatch;
    console.log(body, 'hfg');
    try{
      const data = await lotDispatch(body,categoryId);
      if(data && (data.status === 201 || data.status === 200)){
        dispatchNotification("success", [translate('lotDispatchedSuccessfully')]);
        setConfirmDialog(false);
        handleCloseDispatch(true);
      }
      dispatchShowLoader(false)
    }catch{
      dispatchShowLoader(false)

    }
  }

  const handleSearch = async ()=>{
    const targetManufData = await getTargetManufacturerFromLicense(targetManufLicenseNumber, categoryId)

    setTargetManufId(targetManufData?.data['id'])
    setTargetManufName(targetManufData?.data['name'])


    // setTargetManufId(5)
    // setTargetManufName('jsdk')


  }

  const handleRadioSwitch = (e)=>{
    setManufSelectChoice(e.target.value)
    if(e.target.value == 'dropDown'){
      setLicenseError(false)
      setTargetManufId('')
      setTargetManufName('')
      setTargetManufLicenseNumber('')
    } else if(e.target.value == 'manufLicenseNo'){
      setmanuValue('')
      setManufacturerId('')
    }
  }

  const validateInstructions = (instructions) => {
    if(!instructions){
      return true 
    }
    let validationResult = lengthAndValidCharactersInStringCheck(instructions, translate);
    if (!validationResult['status']) {
      let arrErr = [];
      arrErr.push((outsideDispatch ? translate('vendorDetails') : translate('instructions')) + ": " + validationResult['message'])
      dispatchNotification("error", arrErr);
      return false;
    }
    return true;
  }

  return (
    <>
    <Box className="p-4">
    <Stack direction="column" spacing={2} alignItems="center">
    < Typography>{translate('lotDispatch')}</Typography>
    </Stack>
    <TableContainer sx={{ border: 1, borderColor: " #E0E0E0", marginTop: "20px" }}>
      <Table
        sx={{ minWidth: 900 }}
        className="form-table"
        aria-label="simple table"
      >
        <TableHead>
          <TableRow>
            <TableCell
              
              className="table-head"
              sx={{ border: 1, borderColor: " #E0E0E0", height: "20px" }}
            >
              {translate("S.No")}
            </TableCell>
            <TableCell
              className="table-head"
              sx={{ border: 1, borderColor: " #E0E0E0", height: "20px" }}
              align="left"
            >
              {translate('lotNo-remQty')}
            </TableCell>
            <TableCell
              className="table-head"
              sx={{ border: 1, borderColor: " #E0E0E0", height: "20px" }}
              align="left"
            >
              {translate('quantity')}
            </TableCell>
            <TableCell
              className="table-head"
              sx={{ border: 1, borderColor: " #E0E0E0", height: "20px" }}
              align="left"
            >
              {translate('units')}
            </TableCell>
            <TableCell
                    className="table-head"
                    sx={{ border: 1, borderColor: " #E0E0E0", height: "20px" }}
                    align="left"
                  >
                    {translate('actions')}
                  </TableCell>

          
          
          </TableRow>
        </TableHead>

        <TableBody>
        {chipData &&
                chipData.map((data, idx) => (
              <TableRow
                // key={row.name}
                sx={{
                  "&:last-child td, &:last-child th": {
                    border: 1,
                    borderColor: " #E0E0E0",
                  },
                }}
              >
                <TableCell
                  sx={{
                    border: 1,
                    borderColor: " #E0E0E0",
                    height: "20px",
                  }}
                  component="th"
                  scope="row"
                >
                  {idx+1}
                  {/* {data.readOnly && !hover && <div style={{zIndex:1,display:"block"}}><p>Hello</p></div>} */}

                </TableCell>
             
                <TableCell
                        align="left"
                        sx={{
                          border: 1,
                          borderColor: " #E0E0E0",
                          height: "20px",
                        }}
                      >
                        <Autocomplete
                        
                          // disablePortal
                          id="combo-box-demo"
                          value={data.size}
                          getOptionLabel={(option) => {
                            if (typeof option == "object") return option?.label || "";
                            return (
                              data.size ?
                              `${
                                categoryDropdownData[
                                  data.categoryId
                                ]?.data?.filter(
                                  (dropVal) => dropVal.id === data.size
                                )[0]?.batchName
                              }-${
                                categoryDropdownData[
                                  data.categoryId
                                ]?.data?.filter(
                                  (dropVal) => dropVal.id === data.size
                                )[0]?.lotNo
                              }-${
                                categoryDropdownData[
                                  data?.categoryId
                                ]?.data?.filter(
                                  (dropVal) => dropVal.id === data.size
                                )[0]?.remainingQuantity
                              }-${
                                categoryDropdownData[
                                  data?.categoryId
                                ]?.data?.filter(
                                  (dropVal) => dropVal.id === data.size
                                )[0]?.uom?.name ||
                                categoryDropdownData[
                                  data?.categoryId
                                ]?.data?.filter(
                                  (dropVal) => dropVal.id === data.size
                                )[0]?.uom
                              }` : ''
                            );
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option.value === value
                          }
                          onInputChange={(e) => searchResults(e, data)}
                          onClose={() => {
                            setActiveRow(null);
                            searchResults("");
                          }}
                          onOpen={() => {
                            setActiveRow(idx);
                            fetchData(data?.categoryId, 1);
                          }}
                          onChange={(___, target) => {
                            const { value, extra } = target || {};
                            !value && searchResults("", data);
                            // setShowButton(true);
                            chipData[idx]["size"] = value;
                            chipData[idx]["remaining"] =
                              extra?.remainingQuantity;
                            chipData[idx]["dateOfAcceptance"] =
                            extra?.dateOfAcceptance;
                              setChipData(d=> [...chipData]);
                            // chipData[idx]["comment"] = getBatchComment(extra);
                            // getBatchSizeLot([...chipData]);
                            // getBatchDetailLot([...chipData]);
                          }}
                          options={
                            categoryDropdownData[data?.categoryId]?.data
                              ?.filter(
                                (drop, idx) =>
                                  !chipData
                                    ?.map((data) => data.size)
                                    .includes(drop?.id)
                              )
                              .map((drop) => ({
                                label: `${drop?.batchName}- ${drop?.lotNo}- ${
                                  drop?.remainingQuantity
                                } ${drop?.uom?.name || translate(drop?.uom)}`,
                                value: drop?.id,
                                extra: drop,
                              })) || []
                          }
                          sx={{ width: 250 }}
                          ListboxProps={{
                            style: {
                              maxHeight: "unset",
                              overflow: "unset",
                              boxShadow: "none",
                              marginBottom: 5,
                            },
                            custom: categoryDropdownData[data?.categoryId],
                            fetchData: (fd) => {
                              fetchData(fd, pageNumber + 1);
                            },
                            categoryId: data?.categoryId,
                          }}
                          ListboxComponent={ListboxComponent}
                          PaperComponent={CustomPaperComponent}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="unit"
                              id="outlined-basic"
                              variant="standard"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {sizeLoading && activeRow === idx ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      </TableCell>
                <TableCell
                  sx={{
                    border: 1,
                    borderColor: " #E0E0E0",
                    height: "20px",
                  }}
                  align="left"
                >
                  <TextField
                    
                    sx={{ width: "100%", backgroundColor: "#fff" }}
                    name="quantity"
                    id="outlined-basic"
                    value={data.quantity}
                    type="number"
                    variant="standard"
                    InputProps={{ inputProps: { min: 1 } }}
                    onChange={(event) => {
                    //   setMixUpdated({ quantity: event.target.value, idx });
                    //   setQuantity(event.target.value);
                      chipData[idx]["quantity"] = event.target.value;
                      setChipData([...chipData])
                    //   // setShowButton(true);
                    //   getBatchSizeLot([...chipData]);
                    //   // if(initialMixes[idx] && initialMixes[idx]?.id!==""){
                    //   //   (  (event.target.value==initialMixes[idx]?.quantity)) ? setHideSaveButton(true):setHideSaveButton(false);

                    //   // }

                    //   getBatchDetailLot([...chipData]);
                    }}
                  />
                </TableCell>

                <TableCell
                  sx={{
                    border: 1,
                    borderColor: " #E0E0E0",
                    height: "20px",
                  }}
                  align="left"
                >
                  <TextField
                    // disabled={disableVendorData}
                    sx={{ width: "100%", backgroundColor: "#fff" }}
                    name="unit"
                    id="outlined-basic"
                    value={data.unit}
                    variant="standard"
                    select
                    onChange={(event) => {
                    //   setUnit(event.target.value);
                    //   // setShowButton(true);
                    //   // if(initialMixes[idx] && initialMixes[idx].id!==""){
                    //   //   (  (event.target.value==initialMixes[idx]?.unit)) ? setHideSaveButton(true):setHideSaveButton(false);

                    //   // }
                    //   setMixUpdated({ quantity: event.target.value, idx });

                      chipData[idx]["unit"] = event.target.value;
                      chipData[idx]["uomId"] = uomData.filter(
                        (e) => e.name === event.target.value
                      )[0].id;
                      setChipData([...chipData])
                    //   getBatchSizeLot([...chipData]);

                    //   getBatchDetailLot([...chipData]);
                    console.log(event)
                    }}
                  >
                    {
                      uomData?.map((uom, idx) => {
                        return (
                            
                          <MenuItem value={uom.name}> {translate(uom.name)}</MenuItem>
                        );
                      })}
                  </TextField>
                </TableCell>
                <TableCell
                        sx={{
                          border: 1,
                          borderColor: " #E0E0E0",
                          height: "20px",
                        }}
                        align="left"
                      >
                        <Button
                          sx={{ textDecoration: "underline" }}
                          onClick={() => {
                            handleDeleteRow(idx);
                          }}
                        >
                          {translate('delete')}
                        </Button>
                      </TableCell>
               
               
              </TableRow>
                ))}
           
        </TableBody>
      </Table>
    </TableContainer>

    <div>
      <Dialog
        open={open1}
        onClose={handleClickCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {translate('confirmationMsg')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {translate('confirm-deleteMix')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickCloseDialog} variant="contained">
            {translate('no')}
          </Button>
          <Button
            type="submit"
            variant="contained"
            // onClick={handleClickYes}
            autoFocus
          >
            {translate('yes')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
    <div>
      <Dialog
        open={open1}
        onClose={handleClickSaveCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
        {translate('confirmationMsg')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {translate('confirm-saveMix')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickSaveCloseDialog} variant="contained">
          {translate('no')}
          </Button>
          <Button
            type="submit"
            variant="contained"
            // onClick={handleClickSaveYes}
            onClick={handleClickSaveCloseDialog}
            autoFocus
          >
            {translate('yes')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>

    
            <Button
            //   disabled={disableVendorData}
              sx={{ textDecoration: "underline" }}
              onClick={() => handleAddItem(categoryId)}
            >
              <AddCircleOutlineIcon />
              {translate('addLot')}
            </Button>

        <Stack direction="column"  alignItems="center">

          <Stack direction="row" marginBottom={"20px"} marginTop={"20px"} width={"100%"} spacing={2}>
            {/* <Tooltip title="Lot number will be auto-generated">
              <TextField
                name="lotno"
                id="outlined-basic"
                type="text"
                variant="outlined"
                label="Lot Number"
                sx={{ width: 400 }}
                disabled
              />
            </Tooltip> */}
            <LocalizationProvider dateAdapter={AdapterDayjs} localeText={translateDateSelectActionButtons(translate)}>
              <MobileDatePicker
                label={translate('dispatchDate') + '*'}
                inputFormat="MM/DD/YYYY"
                value={value}
                minDate={new Date(latestDateOfAcceptance)}
                maxDate={new Date()}
                onChange={handleChangeDate}
                onError={(newError) => {
                  if(newError){
                    setDateError(true)
                  }else{
                    setDateError(false)
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} sx={{ width: 400 }} inputProps={{ ...params.inputProps, readOnly: true }} />
                )}
                required
                error={true}
              />
            </LocalizationProvider>
          </Stack>

{/* {
!currentLocation.pathname.includes('miller-lots') && (
          <FormControl>
      <FormLabel id="controlled-radio-buttons-group">Manufacturer Select</FormLabel>
      <RadioGroup
        name="controlled-radio-buttons-group"
        value={manufSelectChoice}
        onChange={(e)=>{handleRadioSwitch(e)}}
        sx={{marginBottom: "10px"}}
      >
        <FormControlLabel value="dropDown" control={<Radio />} label={translate('manufacturerName')} />
        <FormControlLabel value="manufLicenseNo" control={<Radio />} label={translate('licenseNo')} />
      </RadioGroup>
      </FormControl>

)} */}

          { (manufSelectChoice=='manufLicenseNo') &&
      <>
        <Stack direction="row" marginBottom={"10px"}  width={"100%"} spacing={2}>
          <TextField 
          autoComplete="false"
           label="Manufacturer License Number"
           error={licenseError}
           type="string"
           helperText={licenseError && "Please enter a valid 14 digit license number"}
           value={targetManufLicenseNumber}
           onChange={(e)=>{
            if(!(/^\d*$/.test(e.target.value))){
              return;
            }
            if(e.target.value.toString().length != 14){
              setLicenseError(true)
            } else{
              setLicenseError(false)
            }
            setTargetManufLicenseNumber(e.target.value)
          }} 
           sx={{width: '60%',marginBottom: '10px', marginRight:'0px' }}></TextField>

           <Button variant="contained" disabled={licenseError} size="medium" onClick={handleSearch} sx={{ width: 100, alignSelf:'center', marginLeft:'0px' }}>Search</Button>

        </Stack>

            <Stack direction="row" width={"100%"} spacing={2}>

           <TextField value={targetManufName} label="Manufacturer Name" disabled sx={{ width: '60%' }}></TextField>
            </Stack>
            </>
      }

      {

      (manufSelectChoice=='dropDown') &&
                <Stack direction="row"  width={"100%"} spacing={2}>
                  <TextField
                    className="dropdown-size"
                    id="standard-select-currency"
                    select
                    label={translate('manufacturerType')}
                    value={manufacturerType}
                    onChange={(e) => handleChangeFrkType(e)}
                    variant="outlined"
                    required
                    sx={{ width: 400 }}
                  >
                    <MenuItem key={"PUBLIC"} value={"PUBLIC"}>
                    {translate('public')}
                    </MenuItem>
                    <MenuItem key={"PRIVATE"} value={"PRIVATE"}>
                    {translate('private')}
                    </MenuItem>
                  </TextField>

                  {/* <TextField
                    className="dropdown-size"
                    id="standard-select-currency"
                    select
                    label="Target Category"
                    value={"FRK"}
                    onChange={(e) => handleChangeFrkType(e)}
                    variant="outlined"
                    required
                    sx={{ width: 400 }}
                  >
                    <MenuItem key={"FRK"} value={"FRK"}>
                    FRK
                    </MenuItem>
                    <MenuItem key={"MILLER"} value={"MILLER"}>
                    MILLER(FR)
                    </MenuItem>
                  </TextField> */}

                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    clearIcon={<ClearIcon fontSize="small" />}
                    options={frkManufacturerDetails.map((option) => ({
                      label: option.name,
                      value: option.id,
                    }))}
                    filterOptions={options => options}
                    value={
                    manuValue
                    }
                    onInputChange={(e) => e  && setQueryparam(e.target?.value)}
                    onChange={(___, target) => {
                      const { value, extra, label } = target || {};
                      setManufacturerId(value);
                      setmanuValue(label)
                    }}
                    ListboxProps={{
                      style: {
                        maxHeight: "unset",
                        overflow: "unset",
                        boxShadow: "none",
                        marginBottom: 5,
                      },
                      custom: { data: frkManufacturerDetails, count: manufacturerCount },
                      fetchData: () => {
                        fetchFrkManufacturers(manufacturersPageNumber + 1);
                      },
                    }}
                    ListboxComponent={ListboxComponent}
                    onOpen={() => setQueryparam("")}
                    required={!outsideDispatch}
                    disabled={outsideDispatch}
                    error={true}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="medium"
                        sx={{ width: 400 }}
                        variant="outlined"
                        label={translate('manufacturerName')}
                        required
                      />
                    )}
                  />
                  <FormControlLabel
                      value="start"
                      control={<Checkbox />}
                      label={translate('dispatchOutside')}
                      labelPlacement="end"
                      onChange={(event) => {
                      setOutsideDispatch(event.target.checked);
                      setmanuValue('');
                      setmanufacturersPageNumber(1);
                      setManufacturerId("")

                      }}
                    />
                </Stack>
      }



        </Stack>
            <Stack direction="row" marginTop={"20px"} spacing={3} alignItems="baseline">

        <TextField
          sx={{ width: "80%", backgroundColor: "#fff", marginTop: 2, marginBottom: 2 }}
          id="outlined-basic"
          multiline
          minRows={4}
          value={instructions}
          label={outsideDispatch ? translate('vendorDetails'): translate('instructions')}
          type="text"
          variant="outlined"
          onChange={(event) => {
            setInstructions(event.target.value);
           
           
          }}
        />
      </Stack>
          
        <div style={{display: 'flex', justifyContent: 'center'}}>

        <Button
        variant="contained"
        className="mt-2"
         disabled={checkIfDisabled()}
          onClick={() => {
            if(validateInstructions(instructions)){
              setConfirmDialog(true)
            }
             return;
          }}
        >
          {translate('dispatchLot')}
        </Button>
        </div>
        <div>
        <Dialog
          open={confirmDialog}
          onClose={handleClosConfirmation}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
          {translate('confirmationMsg')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            {translate('areYouSureToDispatchLot')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleClosConfirmation}
              variant="contained"
              sx={{ backgroundColor: "grey" }}
            >
              {translate('no')}
            </Button>
            <Button
              type="submit"
              variant="contained"
              onClick={handleSave}
              autoFocus
            >
              {translate('yes')}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    
    </Box>
    </>

  )
}

function CustomPaperComponent(params) {
  const { className, ...rest } = params;
  return <Paper className={`${className} custom-paper`} {...rest} />;
}


export default DispatchLotComponent